export const filterState = {
  type: [],
  location: [],
  salary: [0, 30],
  exp: "all",
  city: "",
  company: "",
  visibility: 1,
  expirationStatus: false,
  isEnabled: true,
  startDate: null,
  endDate: null
};

export const filterAction = {
  SET_TYPE: "SET_TYPE",
  SET_VISIBILITY: "SET_VISIBILITY",
  SET_LOCATION: "SET_LOCATION",
  SET_SALARY: "SET_SALARY",
  SET_EXP: "SET_EXP",
  SET_CITY: "SET_CITY",
  SET_COMPANY: "SET_COMPANY",
  SET_EXPIRATION_STATUS: "SET_EXPIRATION_STATUS",
  SET_IS_ENABLED: "SET_IS_ENABLED",
  SET_START_DATE: "SET_START_DATE",
  SET_END_DATE: "SET_END_DATE",
  RESET_FILTERS: "RESET_FILTERS"
};

// Helper function to validate experience range
export const validateExperience = (exp) => {
  // Handle null, undefined, or "all" values
  if (!exp || exp === "all") return null;

  // If exp is an object with value property
  if (exp && typeof exp === "object" && "value" in exp) {
    const value = exp.value;
    // For 7+ years
    if (value === 7) return [7, 100];
    // For other years, create a range of ±1 year
    return [value, value + 1];
  }

  // Handle numeric values directly
  if (typeof exp === "number") {
    // For 7+ years
    if (exp === 7) return [7, 100];
    // For other years, create a range of ±1 year
    return [exp, exp + 1];
  }

  console.warn("Invalid experience value:", exp);
  return null;
};

// Helper function to validate salary range
const validateSalary = (salary) => {
  if (!Array.isArray(salary) || salary.length !== 2) return [0, 30];
  return salary.map((val) => Math.max(0, Math.min(100, val)));
};

export function filterReducer(state, action) {
  switch (action.type) {
    case filterAction.SET_TYPE:
      return {
        ...state,
        type: Array.isArray(action.payload) ? action.payload : [action.payload]
      };
    case filterAction.SET_LOCATION:
      return {
        ...state,
        location: Array.isArray(action.payload) ? action.payload : [action.payload]
      };
    case filterAction.SET_SALARY:
      return {
        ...state,
        salary: action.payload || [0, 30]
      };
    case filterAction.SET_EXP:
      return {
        ...state,
        exp: action.payload || "all"
      };
    case filterAction.SET_CITY:
      return {
        ...state,
        city: action.payload?.trim() || ""
      };
    case filterAction.SET_COMPANY:
      return {
        ...state,
        company: action.payload?.trim() || ""
      };
    case filterAction.SET_VISIBILITY:
      return {
        ...state,
        visibility: action.payload
      };
    case filterAction.SET_EXPIRATION_STATUS:
      return {
        ...state,
        expirationStatus: action.payload
      };
    case filterAction.SET_IS_ENABLED:
      return {
        ...state,
        isEnabled: action.payload
      };
    case filterAction.SET_START_DATE:
      return {
        ...state,
        startDate: action.payload
      };
    case filterAction.SET_END_DATE:
      return {
        ...state,
        endDate: action.payload
      };
    case filterAction.RESET_FILTERS:
      return { ...filterState };
    default:
      return state;
  }
}
